import { useEffect } from 'react';

import {
  isSuggestionAudioUnlocked,
  unlockSuggestionAudio,
} from './suggestionSound';
import { AUDIO_UNLOCK_EVENTS } from '../../utils/constants/suggestionTabAlerts';

export function useUnlockAudioOnInteraction(): void {
  useEffect(() => {
    if (isSuggestionAudioUnlocked()) return;
    const options: AddEventListenerOptions = { capture: true, once: true };
    const removeAll = () => {
      for (const eventName of AUDIO_UNLOCK_EVENTS) {
        window.removeEventListener(eventName, onInteraction, options);
      }
    };
    function onInteraction() {
      removeAll();
      unlockSuggestionAudio();
    }
    for (const eventName of AUDIO_UNLOCK_EVENTS) {
      window.addEventListener(eventName, onInteraction, options);
    }
    return removeAll;
  }, []);
}
